module.exports = __webpack_public_path__ + "static/media/Note-Click-Bloom-Textures-Click_Boom_00047.af98424b.png";